<template>
  <div class="section modes-section">
    <div class="container">
      <p class="is-size-3 is-size-4-touch subtitle has-text-centered">
        With a link between students and teachers
      </p>
      <br />
      <div class="columns is-centered">
        <div class="column is-8-desktop is-7-widescreen is-6-fullhd">
          <div class="content is-size-5 is-size-7-touch">
            <ul>
              <li>Every user can be both a student and a tutor</li>
              <li>Students can connect to multiple tutors</li>
              <li>Tutors can have multiple students</li>
              <li>Students can share their recordings with tutors</li>
              <li>Tutors can listen and give feedback to shared recordings</li>
              <li>Tutors can follow the progress of their students</li>
            </ul>
          </div>
        </div>
      </div>
      <br />
      <figure class="pic">
        <img
          :data-src="require('@/assets/bubble-teacher.webp')"
          class="lazyload"
          alt="Reading mode"
        />
      </figure>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
